import '../Maintenance/maintenance.scss';

import { format } from 'date-fns';
import * as React from 'react';
import Dialog from 'react-bootstrap-dialog';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from 'src/interfaces';

import { UserModel } from '../../model/UserModel';
import { getAllPlantsByRegion } from '../../services/plantService';
import { deleteUser, getUser, updatePasswordUser } from '../../services/userService';
import { getCurrentUserUUID } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { ErrorPage } from '../reusableComponents/ErrorPage';
import { Loader } from '../reusableComponents/Loader';

export interface IUserProfileProps {
    userInstance: UserModel;
    currentUserInstance: UserModel;
    userId: number;
    history: IHistory;
}

export interface IUserProfileState {
    showConfirmationModal: boolean;
}

export class UserProfileImpl extends React.Component<IUserProfileProps, IUserProfileState> {
    constructor(props: IUserProfileProps) {
        super(props);
        this.state = { showConfirmationModal: false };
    }

    componentDidMount() {
        Dialog.setOptions({
            defaultOkLabel: 'Yes',
            defaultCancelLabel: 'No',
        });
    }

    promise = async () => {
        await getAllPlantsByRegion(this.props.userId);
        await getUser(this.props.userId);
    }

    dialog: Dialog = null;

    handleUserDelete = () => {
        this.dialog.show({
            body: `Are you sure you want to delete user ${this.props.userInstance.props.First_Name}?`,
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() => deleteUser(this.props.userInstance.props.id, this.props.history))
            ]
        });
    }
    handleUserPasswordUpdate = () => {
        this.dialog.show({
            body: `Are you sure you want to update password for user ${this.props.userInstance.props.First_Name}?`,
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() => updatePasswordUser(this.props.userInstance.props.id, this.props.history))
            ]
        });
    }
    renderUserButtons = () => {
        if (this.props.currentUserInstance && this.props.currentUserInstance.props.Access_Level !== 'L1') {
            return '';
        }
        return <div className="buttons-container" >
            {getCurrentUserUUID() === this.props.userInstance.props.id ? '' : <div
                onClick={this.handleUserPasswordUpdate}
                title={`Click to Update password of user ${this.props.userInstance.props.First_Name}`}
                className="delete-details-button" >
                <i className="fa fa-unlock" aria-hidden="true"></i>
            </div>}
            <div
                onClick={() => this.props.history.push(`/user/update/${this.props.userInstance.props.id}`)}
                title={`Click to Edit the Details of User ${this.props.userInstance.props.First_Name}`}
                className="edit-details-button" >
                <i className="fa fa-pencil" aria-hidden="true"></i>
            </div>
            {getCurrentUserUUID() === this.props.userInstance.props.id ? '' : <div
                onClick={this.handleUserDelete}
                title={`Click to Delete user ${this.props.userInstance.props.First_Name}`}
                className="delete-details-button" >
                <i className="fa fa-trash" aria-hidden="true"></i>
            </div>}
            
        </div>;
    }

    renderUserDetails = () => {
        if (!this.props.userInstance) {
            return <div></div>;
        }
        let { props: { UserId, Job_Title, Regions, Access_Level, Last_Name, Job_Desc, Last_Updated,
            Date_Created, Middle_Name, PlantIds, First_Name, Email,
        } } = this.props.userInstance;
        let plantNames = PlantIds;
        if (Access_Level === 'L1') {
            Regions = ['All'];
            plantNames = ['All'];
        }
        return <div style={{ padding: '2vh' }} className="details-page-wrapper">
            <Dialog className="confirmation-modal" ref={(el) => { this.dialog = el; }} />
            <div className="details-left-section" style={{ width: '100%' }} >
                <DisplayDetails label="User ID" value={UserId} />
                <DisplayDetails label="Full Name" value={`${First_Name} ${Middle_Name || ''} ${Last_Name}`} />
                <DisplayDetails label="Access Level" value={Access_Level} />
                <DisplayDetails label="Job Title" value={Job_Title} />
                <DisplayDetails label="Job Description" value={Job_Desc} />
                <DisplayDetails label="Email" value={Email} />
                <DisplayDetails label="Regions" value={Regions.toString()} />
                <DisplayDetails label="Plants" value={plantNames.join(', ')} />
                <DisplayDetails label="Date Created" value={format(Date_Created, 'MM/DD/YYYY')} />
            </div>
            {this.renderUserButtons()}
        </div >;
    }

    render() {
        return (
            <BasePage pageTitle="User Information" >
                <Async
                    identifier="UserProfile"
                    promise={this.promise}
                    loader={<Loader type="async" />}
                    error={<ErrorPage />}
                    content={this.renderUserDetails()}
                />
            </BasePage>
        );
    }

}

export function mapStateToProps(state, ownProps) {
    const userInstance = UserModel.get(ownProps.match.params.id);
    const userId = state.login.get('UniqueId');
    const currentUserInstance = UserModel.get(userId, state);
    return {
        userInstance, currentUserInstance,
        userId: ownProps.match.params.id
    };
}

export const Profile = withRouter(connect<{}, {}, IUserProfileProps>(mapStateToProps)(UserProfileImpl as any));

const DisplayDetails = ({ label, value }) => {
    return <div className="details-row" >
        <Label labelText={label} />
        <Value value={value} />
    </div>;
};

const Label = ({ labelText }) => {
    return <div className="details-label" >
        {labelText}:
    </div>;
};

const Value = ({ value }) => {
    return <div className="details-value">
        {value || 'NA'}
    </div>;
};

const modalHeader: React.CSSProperties = {
    backgroundColor: '#A4BF43',
    border: 'none',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Profile/index.tsx